import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { DateFormaterMonth } from "../../Components/GlobalFunctions";
import { ContentLoader } from "../../Components/Shimmer";
import "./PreviewStatus.css";

const PreviewStatus = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const { project_request_id } = useParams();
    const [loadingList, setLoadingList] = useState(false);
    const [consultantInfo, setConsultantInfo] = useState([]);
    const [clearanceConsultants, setClearanceConsultants] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [requestedInfo, setRequestedInfo] = useState({});
    const navigate = useNavigate();

    const Labels = (status) => {
        if (status === 0) return "Pending";
        if (status === 1) return "Approved";
        if (status === 2) return "Revise";
        if (status === 3) return "Rejected";
        if (status === 4) return "In-Clearence";
        return "-";
    };

    const Classes = (status) => {
        if (status === 0) return "badge bg-warning-subtle text-warning";
        if (status === 1) return "badge bg-success-subtle text-success";
        if (status === 2) return "badge bg-info-subtle text-info";
        if (status === 3) return "badge bg-danger-subtle text-danger";
        if (status === 4) return "badge bg-secondary-subtle text-secondary";
        return "badge bg-light text-dark";
    };

    const GetInfo = async () => {
        try {
            setLoadingList(true);

            const response = await axios.get(
                `${apiURL}api/requests/GetProjectRequestInfo?project_request_id=${project_request_id}`,
                { headers: apiHeaderJson }
            );

            const { data, success } = response.data;

            if (success) {
                setRequestedInfo(data.info);
                setConsultantInfo(data.consultants || []);
                setClearanceConsultants(
                    data.projects__request_clearance || []
                );
                setAttachments(data.attachments || []);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingList(false);
        }
    };

    useEffect(() => {
        if (project_request_id) GetInfo();
    }, [project_request_id]);

    const Signature = ({ signature, alt }) => (
        <div className="signature-container">
            {signature ? (
                <img
                    className="signature-image"
                    src={`${apiURL}api/profile-signature/${signature} `}
                    alt={alt}
                    onError={(e) => {
                        e.target.style.display = "none";
                        e.target.parentElement.innerHTML =
                            '<p class="text-muted mb-0">No Signature Available</p>';
                    }}
                />
            ) : (
                <p className="text-muted mb-0">No Signature Available</p>
            )}
        </div>
    );

    return (
        <>
            {loadingList ? (
                <ContentLoader />
            ) : (
                <div className="center-form-wrapper">
                    <div className="vi-container shadow-none border">
                        <div className="vi-preview shadow-none printable-area">
                            <div className="row justify-content-center">
                                <div className="col-xxl-9">
                                    <div className="card" id="demo">
                                        <div className="card-body">

                                            {/* HEADER / PROJECT */}
                                            <div className="vi-participant-section">
                                                <div className="vi-logo">
                                                    <img
                                                        src="/assets/images/new_logo.png"
                                                        alt="Company Logo"
                                                        onError={(e) => {
                                                            e.target.style.display = "none";
                                                        }}
                                                    />
                                                </div>

                                                <div className="vi-participant">
                                                    <p>{requestedInfo?.project_title}</p>
                                                    <h6>Project</h6>

                                                    <div className="row">
                                                        <div className="col-6">
                                                            <p>
                                                                {DateFormaterMonth(
                                                                    requestedInfo?.project_start_date
                                                                )}
                                                            </p>
                                                            <h6>Start Date</h6>
                                                        </div>

                                                        <div className="col-6">
                                                            <p>
                                                                {DateFormaterMonth(
                                                                    requestedInfo?.project_end_date
                                                                )}
                                                            </p>
                                                            <h6>End Date</h6>
                                                        </div>

                                                        <div className="col-12 mt-2">
                                                            <p>
                                                                {requestedInfo?.project_address}
                                                            </p>
                                                            <h6>Location</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="header">
                                                <div className="row mb-1 mt-2">
                                                    <div className="col-md-3 fw-bold">
                                                        Ref. # :{" "}
                                                        {requestedInfo?.project_request_id}
                                                    </div>

                                                    <div className="col-md-3">
                                                        Rev # :{" "}
                                                        {requestedInfo?.request_revision_count}
                                                    </div>

                                                    <div className="col-md-6">
                                                        Request Date :{" "}
                                                        {DateFormaterMonth(
                                                            requestedInfo?.request_date
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* PROJECT DETAILS */}
                                            <div className="preview-section">
                                                <div className="section-title">
                                                    Project Details
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <InfoItem
                                                            label="Project Title"
                                                            value={requestedInfo?.project_title}
                                                        />
                                                        <InfoItem
                                                            label="Project Description"
                                                            value={requestedInfo?.project_description}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <InfoItem
                                                            label="Project Address"
                                                            value={requestedInfo?.project_address}
                                                        />
                                                        <InfoItem
                                                            label="Pin Code"
                                                            value={requestedInfo?.project_pin_code}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* ITEM / REQUEST DETAILS */}
                                            <div className="preview-section">
                                                <div className="section-title">
                                                    Request Details
                                                </div>

                                                <div className="table-responsive">
                                                    <table className="table table-bordered align-middle mb-3">
                                                        <thead>
                                                            <tr className="table-active">
                                                                <th>Sr.No</th>
                                                                <th>Item Name</th>
                                                                <th>Quantity</th>
                                                                <th>Received Qty</th>
                                                                <th>Unit</th>
                                                                <th>Price</th>
                                                                <th>Delivery Date</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr>
                                                                <td>1</td>
                                                                <td>
                                                                    {requestedInfo?.item_name}
                                                                </td>
                                                                <td>
                                                                    {requestedInfo?.pi_item_qty}
                                                                </td>
                                                                <td>
                                                                    {requestedInfo?.pi_item_received_qty ??
                                                                        "-"}
                                                                </td>
                                                                <td>
                                                                    {requestedInfo?.item_unit}
                                                                </td>
                                                                <td>
                                                                    {requestedInfo?.pi_item_price}
                                                                </td>
                                                                <td>
                                                                    {DateFormaterMonth(
                                                                        requestedInfo?.pi_item_delivery_date
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <InfoItem
                                                            label="Type Of Submittal"
                                                            value={
                                                                requestedInfo?.submittal_description
                                                            }
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <InfoItem
                                                            label="Status"
                                                            value={
                                                                <span
                                                                    className={`status-stamp status-${requestedInfo?.request_status}`}
                                                                >
                                                                    {Labels(requestedInfo?.request_status)}
                                                                </span>
                                                            }
                                                        />
                                                    </div>

                                                    <div className="col-md-12">
                                                        <InfoItem
                                                            label="Brief Description"
                                                            value={
                                                                requestedInfo?.request_brief_description
                                                            }
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <InfoItem
                                                            label="Consultant Revision"
                                                            value={
                                                                requestedInfo?.request_revision_remark ??
                                                                "-"
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* CONTRACTOR */}
                                            <div className="preview-section">
                                                <div className="section-title">
                                                    Contractor Details
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <InfoItem
                                                            label="Name"
                                                            value={requestedInfo?.profile_name}
                                                        />
                                                        <InfoItem
                                                            label="About"
                                                            value={requestedInfo?.profile_about}
                                                        />
                                                        <InfoItem
                                                            label="Contact"
                                                            value={requestedInfo?.profile_contact_number}
                                                        />
                                                        <InfoItem
                                                            label="Email"
                                                            value={requestedInfo?.profile_email}
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <label className="text-muted text-uppercase fw-semibold">
                                                            Digital Signature
                                                        </label>

                                                        <Signature
                                                            signature={
                                                                requestedInfo?.digital_signature
                                                            }
                                                            alt="Contractor Signature"
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* CONSULTANT */}
                                            <div className="preview-section">
                                                <div className="section-title">
                                                    Consultant Details
                                                </div>

                                                {consultantInfo?.length > 0 ? (
                                                    consultantInfo.map(
                                                        (consultant) => (
                                                            <div
                                                                className="row consultant-block"
                                                                key={
                                                                    consultant.project_request_consultant_id
                                                                }
                                                            >
                                                                <div className="col-md-6">
                                                                    <InfoItem
                                                                        label="Name"
                                                                        value={
                                                                            consultant.profile_name
                                                                        }
                                                                    />
                                                                    <InfoItem
                                                                        label="About"
                                                                        value={
                                                                            consultant.profile_about
                                                                        }
                                                                    />
                                                                    <InfoItem
                                                                        label="Contact"
                                                                        value={
                                                                            consultant.profile_contact_number
                                                                        }
                                                                    />
                                                                    <InfoItem
                                                                        label="Email"
                                                                        value={
                                                                            consultant.profile_email
                                                                        }
                                                                    />
                                                                    <InfoItem
                                                                        label="Comment"
                                                                        value={
                                                                            consultant.consultant_remark ??
                                                                            "-"
                                                                        }
                                                                    />
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <label className="text-muted text-uppercase fw-semibold">
                                                                        Digital Signature
                                                                    </label>

                                                                    <Signature
                                                                        signature={
                                                                            consultant.digital_signature
                                                                        }
                                                                        alt="Consultant Signature"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    )
                                                ) : (
                                                    <p className="text-muted mb-0">
                                                        No Consultant Assigned
                                                    </p>
                                                )}
                                            </div>

                                            {/* CLEARANCE CONSULTANT */}
                                            <div className="preview-section">
                                                <div className="section-title">
                                                    Clearance Consultant Details
                                                </div>

                                                {clearanceConsultants?.length > 0 ? (
                                                    clearanceConsultants.map(
                                                        (consultant) => (
                                                            <div
                                                                className="row consultant-block"
                                                                key={
                                                                    consultant.project_request_clearance_id
                                                                }
                                                            >
                                                                <div className="col-md-6">
                                                                    <InfoItem
                                                                        label="Name"
                                                                        value={
                                                                            consultant.profile_name
                                                                        }
                                                                    />
                                                                    <InfoItem
                                                                        label="About"
                                                                        value={
                                                                            consultant.profile_about
                                                                        }
                                                                    />
                                                                    <InfoItem
                                                                        label="Contact"
                                                                        value={
                                                                            consultant.profile_contact_number
                                                                        }
                                                                    />
                                                                    <InfoItem
                                                                        label="Email"
                                                                        value={
                                                                            consultant.profile_email
                                                                        }
                                                                    />
                                                                    <InfoItem
                                                                        label="Clearance Comment"
                                                                        value={
                                                                            consultant.clearance_remark ??
                                                                            "-"
                                                                        }
                                                                    />
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <label className="text-muted text-uppercase fw-semibold">
                                                                        Digital Signature
                                                                    </label>

                                                                    <Signature
                                                                        signature={
                                                                            consultant.digital_signature
                                                                        }
                                                                        alt="Clearance Consultant Signature"
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    )
                                                ) : (
                                                    <p className="text-muted mb-0">
                                                        No Clearance Consultant Assigned
                                                    </p>
                                                )}
                                            </div>

                                            {/* ATTACHMENTS */}
                                            <div className="preview-section">
                                                <div className="section-title">
                                                    Attachments
                                                </div>

                                                {attachments?.length > 0 ? (
                                                    <div className="row g-3">
                                                        {attachments.map(
                                                            (attachment) => {
                                                                const fileUrl =
                                                                    attachment.attachment_path;

                                                                const fileName =
                                                                    decodeURIComponent(
                                                                        fileUrl
                                                                            .split(
                                                                                "/"
                                                                            )
                                                                            .pop()
                                                                    );

                                                                const extension =
                                                                    fileName
                                                                        .split(
                                                                            "."
                                                                        )
                                                                        .pop()
                                                                        .toLowerCase();

                                                                const isImage = [
                                                                    "jpg",
                                                                    "jpeg",
                                                                    "png",
                                                                    "gif",
                                                                    "webp",
                                                                    "bmp",
                                                                    "svg",
                                                                ].includes(
                                                                    extension
                                                                );

                                                                const isPdf =
                                                                    extension ===
                                                                    "pdf";

                                                                return (
                                                                    <div
                                                                        key={
                                                                            attachment.project_request_attachment_id
                                                                        }
                                                                        className="col-md-6 col-lg-4"
                                                                    >
                                                                        <div className="border rounded p-3 h-100">
                                                                            {isImage ? (
                                                                                <div className="text-center mb-3">
                                                                                    <img
                                                                                        src={
                                                                                            fileUrl
                                                                                        }
                                                                                        alt={
                                                                                            fileName
                                                                                        }
                                                                                        className="img-fluid rounded"
                                                                                        style={{
                                                                                            maxHeight:
                                                                                                "180px",
                                                                                            objectFit:
                                                                                                "contain",
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            ) : (
                                                                                <div className="attachment-file-preview">
                                                                                    <i
                                                                                        className={
                                                                                            isPdf
                                                                                                ? "ri-file-pdf-2-fill text-danger"
                                                                                                : "ri-attachment-2 text-secondary"
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            )}

                                                                            <div className="d-flex align-items-center justify-content-between gap-2">
                                                                                <div
                                                                                    className="text-truncate"
                                                                                    title={
                                                                                        fileName
                                                                                    }
                                                                                >
                                                                                    <i
                                                                                        className={
                                                                                            isPdf
                                                                                                ? "ri-file-pdf-line text-danger me-2"
                                                                                                : isImage
                                                                                                    ? "ri-image-line text-primary me-2"
                                                                                                    : "ri-attachment-2 me-2"
                                                                                        }
                                                                                    />
                                                                                    {fileName}
                                                                                </div>

                                                                                <a
                                                                                    href={
                                                                                        fileUrl
                                                                                    }
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    className="btn btn-sm btn-outline-primary no-print flex-shrink-0"
                                                                                >
                                                                                    <i className="ri-eye-line me-1" />
                                                                                    View
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                ) : (
                                                    <p className="text-muted mb-0">
                                                        No Attachments Available
                                                    </p>
                                                )}
                                            </div>

                                            {/* INSPECTION FORM */}
                                            {requestedInfo?.inspection_id &&
                                                Number(
                                                    requestedInfo.inspection_id
                                                ) > 0 ? (
                                                <div className="preview-section no-print">
                                                    <div className="section-title">
                                                        Inspection
                                                    </div>

                                                    <div
                                                        className="inspection-form-card"
                                                        onClick={() =>
                                                            navigate(
                                                                `/ClearenceList/ViewSubmittedInspectionForm/${requestedInfo?.inspection_id}`
                                                            )
                                                        }
                                                    >
                                                        <div className="inspection-form-icon">
                                                            <i className="ri-file-list-3-line" />
                                                        </div>

                                                        <div>
                                                            <h6 className="mb-1">
                                                                View Inspection
                                                                Form
                                                            </h6>

                                                            <p className="text-muted mb-0">
                                                                Open submitted
                                                                inspection form
                                                            </p>
                                                        </div>

                                                        <i className="ri-arrow-right-line inspection-arrow" />
                                                    </div>
                                                </div>
                                            ) : null}

                                            {/* SUBMITTED BY */}
                                            <div className="preview-section">
                                                <div className="section-title">
                                                    Submitted By
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <InfoItem
                                                            label="Name"
                                                            value={
                                                                requestedInfo?.profile_name
                                                            }
                                                        />
                                                    </div>

                                                    <div className="col-md-6">
                                                        <InfoItem
                                                            label="Position"
                                                            value={
                                                                requestedInfo?.profile_about ??
                                                                "-"
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* ACTIONS */}
                                            <div className="vi-actions no-print mt-4">
                                                <button
                                                    className="btn btn-success float-end"
                                                    onClick={() =>
                                                        window.print()
                                                    }
                                                >
                                                    Print
                                                    <i className="ri-printer-line ms-2" />
                                                </button>

                                                <button
                                                    className="btn btn-info float-end me-2"
                                                    onClick={() =>
                                                        navigate(-1)
                                                    }
                                                >
                                                    Go Back
                                                    <i className="ri-arrow-go-back-line ms-2" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const InfoItem = ({ label, value }) => (
    <div className="info-item mb-3">
        <p className="text-muted mb-1 text-uppercase fw-semibold">
            {label}
        </p>
        <div className="fs-14">{value ?? "-"}</div>
    </div>
);

export default PreviewStatus;